import withApiData from "../withApiData";
import LandingFooter from "./LandingFooter";
import Placeholder from "./Placeholder";

export default withApiData(LandingFooter, Placeholder);
